import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { Subscription } from 'rxjs';
import { Program } from 'src/app/shared/models/programs';
import { CardsService } from 'src/app/shared/services/cards.service';
import { ProgramsService } from 'src/app/shared/services/programs.service';
import { UtilitiesService } from 'src/app/shared/services/utilities.service';

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.scss']
})
export class ProgramComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  id: string;
  isEditing = false;
  program: Program;
  // buttonOptions: any = {
  //   text: 'Salvar programa',
  //   type: 'default',
  //   useSubmitBehavior: true,
  //   horizontalAlignment: 'right',
  //   onClick: 'this.onFormSubmit()',
  // };
  cardsObj = [];
  tempStartDate: any;
  tempEndDate: any;
  btnIsDisabled: boolean = true;

  constructor(
    private programsService: ProgramsService,
    private utilitiesService: UtilitiesService,
    private route: ActivatedRoute,
    private router: Router,
    private cardsService: CardsService,
  ) {
    // Get ID from URL
    if (this.route.snapshot.params['id']) {
      this.id = this.route.snapshot.params['id'];
      this.isEditing = true;
      this._subscriptions.push(
        this.programsService.getProgram(this.id).subscribe(program => {
          this.program = program;
          this.tempStartDate = this.utilitiesService.numberToDate(program.startDate).date;
          this.tempEndDate = this.utilitiesService.numberToDate(program.endDate).date;
        })
      );
    } else {
      this.program = new Program();
    }
  }

  ngOnInit() {
    this._subscriptions.push(
      this.cardsService.getCards().subscribe(cards => {
        this.cardsObj = cards;
        console.log(cards);
      })
    );
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

  // setCardType(data){
  //   console.log(data);
  //   this.program.cardTypeName = data.cardName;
  //   this.program.cardTypeId = data.id;
  // }

  onFormSubmit(params) {
    if (params.validationGroup.validate().isValid) {
      this.program.startDate = this.utilitiesService.dateToNumber(this.tempStartDate);
      this.program.endDate = this.utilitiesService.dateToNumber(this.tempStartDate);
      this.program.dateCreated = this.utilitiesService.dateToNumber(new Date());
      this.programsService.newProgram(this.program).then(data => {
        this.utilitiesService.notifyMeAndRedirect('Programa guardado', 'success', '/dash/programs');
      })
    }
  }

  onFormUpdateSubmit(params) {
    if (params.validationGroup.validate().isValid) {
      this.program.startDate = this.utilitiesService.dateToNumber(this.tempStartDate);
      this.program.endDate = this.utilitiesService.dateToNumber(this.tempStartDate);
      this.program.dateCreated = this.utilitiesService.dateToNumber(new Date());
      this.programsService.updateProgram(this.id, this.program).then(data => {
        this.utilitiesService.notifyMeAndRedirect('Programa actualizado', 'success', '/dash/programs');
      });
    }
  }

}
